import {h, Component, ComponentChildren} from 'preact'

type TopOrBottom = 'top' | 'bottom'

interface State {
  show: null | TopOrBottom,
  x: number,
  y: number,
  width: number,
}

interface Props {
  children: ComponentChildren,
  x: number,
  y: number,
  resolvedPosition: (position: TopOrBottom, x: number, y: number, width: number) => void
}

export default class Mover extends Component<Props, State> {
  ref: HTMLElement | undefined

  constructor () {
    super()
    this.state = {show: null, x: 0, y: 0, width: 0}
  }

  componentWillReceiveProps (nextProps: Props) {
    if (nextProps.x === this.props.x && nextProps.y === this.props.y) return
    if (!this.ref?.parentElement) return
    const rect = this.ref.parentElement.getBoundingClientRect()
    const {x, y} = nextProps

    const inside = x > rect.left - 65 && y > rect.top && x < rect.right && y < rect.bottom

    if (!inside) return this.setState({show: null})
    const topOrBottom = ((rect.bottom + rect.top) / 2) > y ? 'top' : 'bottom'

    const resolvedX = rect.left
    const resolvedY = topOrBottom === 'top' ? rect.top + 1 : rect.bottom
    const bodyRect = document.body.getBoundingClientRect()
    this.props.resolvedPosition(
      topOrBottom,
      Math.round(resolvedX - bodyRect.left),
      Math.round(resolvedY - bodyRect.top),
      rect.width
    )
  }

  shouldComponentUpdate (nextProps: Props, nextState: State) {
    return nextState.show !== this.state.show || this.props.children !== nextProps.children
  }

  render () {
    return <div ref={ref => this.ref = ref}>
      {this.props.children}
    </div>
  }
}
